<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <template>
            <el-tabs v-model="ActiveTab">
              <el-tab-pane :label="$t('title.country')" name="Country">
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addCountry") }}</el-button
                  >
                  
              <div class="tableDiv">
                  <table-region
                    :isShowKArea="false"
                    :isShowKCenter="false"
                    :isShowOffice="false"
                    :tableData="tableData1"
                    :tableType="(tableType = 'Country')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-region>
              </div>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('title.region')" name="Area">
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addRegion") }}</el-button
                  >
                   <div class="tableDiv">
                  <table-region
                    :isShowKArea="true"
                    :isShowKCenter="false"
                    :isShowOffice="false"
                    :tableData="tableData2"
                    :tableType="(tableType = 'Area')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-region>
                   </div>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('title.customerCenter')" name="Center">
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addCustomerCenter") }}</el-button
                  >
                   <div class="tableDiv">
                  <table-region
                    :isShowKArea="true"
                    :isShowKCenter="true"
                    :isShowOffice="false"
                    :tableData="tableData3"
                    :tableType="(tableType = 'Center')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-region>
                   </div>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('title.liaison')" name="Office">
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addLiaisonOffice") }}</el-button
                  >
                  <el-button
                    type="default"
                    icon="el-icon-download"
                    style="margin-bottom: 10px"
                    @click="exportCustomerRegionList()"
                    :loading="loading"
                    v-if="hasExportAuth"
                    >{{ $t("button.exportAll") }}</el-button
                  >
                   <div class="tableDiv">
                  <table-region
                    :isShowKArea="true"
                    :isShowKCenter="true"
                    :isShowOffice="true"
                    :tableData="tableData4"
                    :tableType="(tableType = 'Office')"
                    :regionType = "regionType"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @showCityDialog="showCityDialog"
                    @delRow="delRow"
                  >
                  </table-region>
                   </div>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <dialog-country
      ref="addRef1"
      :dialogAddClient="dialogAdd1"
      :formRef="'countryAddRef'"
      :title="(dialogTitle = $t('button.addCountry'))"
      :Countryform="Countryform"
      :subButtonAuth="hasCreateAuth"
      :loading="submitLoading"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addCustomerCenter"
    >
    </dialog-country>

    <dialog-area
      ref="addRef2"
      :dialogAddClient="dialogAdd2"
      :formRef="'areaAddRef'"
      :title="(dialogTitle = $t('button.addRegion'))"
      :Areaform="Areaform"
      :MTypeTable="tableData1"
      :subButtonAuth="hasCreateAuth"
      :loading="submitLoading"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addCustomerCenter"
    >
    </dialog-area>

    <dialog-center
      ref="addRef3"
      :dialogAddClient="dialogAdd3"
      :formRef="'centerAddRef'"
      :title="(dialogTitle = $t('button.addCustomerCenter'))"
      :Centerform="Centerform"
      :MTypeTable="tableData1"
      :MProductTable="MPOptions"
      :subButtonAuth="hasCreateAuth"
      :regionType = "regionType"
      :loading="submitLoading"
      @selMTChange="selMTChange"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addCustomerCenter"
    >
    </dialog-center>

    <dialog-office
      ref="addRef4"
      :dialogAddClient="dialogAdd4"
      :formRef="'officeAddRef'"
      :title="(dialogTitle = $t('button.addLiaisonOffice'))"
      :Officeform="Officeform"
      :MTypeTable="tableData1"
      :MProductTable="MPOptions"
      :MSmallTable="MSOptions"
      :subButtonAuth="hasCreateAuth"
      :optionRegion="optionRegion"
      :loading="submitLoading"
      @selMTChange="selMTChange"
      @selMPChange="selMPChange"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addCustomerCenter"
    >
    </dialog-office>

    <dialog-country
      ref="editRef1"
      :dialogAddClient="dialogEdit1"
      :formRef="'countryEditRef'"
      :title="(dialogTitle = $t('button.updateCountry'))"
      :Countryform="Countryform"
      :subButtonAuth="hasUpdateAuth"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateCustomerCenter"
    >
    </dialog-country>

    <dialog-area
      ref="editRef2"
      :dialogAddClient="dialogEdit2"
      :formRef="'areaEditRef'"
      :title="(dialogTitle = $t('button.updateRegion'))"
      :Areaform="Areaform"
      :MTypeTable="MTOptions"
      :subButtonAuth="hasUpdateAuth"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateCustomerCenter"
    >
    </dialog-area>

    <dialog-center
      ref="editRef3"
      :dialogAddClient="dialogEdit3"
      :formRef="'centerEditRef'"
      :title="(dialogTitle = $t('button.updateCustomerCenter'))"
      :Centerform="Centerform"
      :MTypeTable="MTOptions"
      :MProductTable="MPOptions"
      :subButtonAuth="hasUpdateAuth"
      :regionType = "regionType"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateCustomerCenter"
    >
    </dialog-center>

    <dialog-office
      ref="editRef4"
      :dialogAddClient="dialogEdit4"
      :formRef="'officeEditRef'"
      :title="(dialogTitle = $t('button.updateLiaisonOffice'))"
      :Officeform="Officeform"
      :MTypeTable="MTOptions"
      :MProductTable="MPOptions"
      :MSmallTable="MSOptions"
      :subButtonAuth="hasUpdateAuth"
      :optionRegion="optionRegion"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateCustomerCenter"
    >
    </dialog-office>
    <dialog-city
      ref="ref5"
      :dialogAddClient="dialogCity"
      :dialogAdd="dialogAddCity"
      :title="(dialogTitle = $t('button.managementArea'))"
      :cityTable="cityTable"
      :optionRegion="optionRegion"
      :Cityform="Cityform"
      :loading="cityLoading"
      @dialogVisibleEvent="showCityDialog"
      @delCity="delCity"
      @onSubBtn="addCity"
      @showAddCityDialog="showAddCityDialog"
    >
    </dialog-city>
  </div>
</template>

<script>
import {
  getCustomerRegionTable,
  getCustomerRegionById,
  deleteCustomerRegion,
  updateCustomerCenter,
  addCustomerCenter,
  getCustomerRegionList,
  addRangeCustomerRegion,
  deleteRangeCustomerRegion,
  authOperationCheck,
  getRegionTree,
  addCustomerCity,
  deleteCustomerCity,
  getCustomerCityList,
  exportExcelNew,
} from "../../api/api";
import { mapState } from "vuex";
import dialogArea from "../../components/content/custRegion/DialogArea";
import dialogCenter from "../../components/content/custRegion/DialogCenter";
import dialogCountry from "../../components/content/custRegion/DialogCountry";
import dialogOffice from "../../components/content/custRegion/DialogOffice";
import tableRegion from "../../components/content/custRegion/TableRegion";
import dialogCity from "../../components/content/custRegion/DialogCity";
export default {
  name: "index",
  components: {
    "dialog-area": dialogArea,
    "dialog-center": dialogCenter,
    "dialog-country": dialogCountry,
    "dialog-office": dialogOffice,
    "dialog-city": dialogCity,
    "table-region": tableRegion,
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    return {
      submitLoading:false,
      cityLoading:false,
      regionType:"BV",
      loading:false,
      hasExportAuth:false,
      ActiveTab: "Country",
      tableType: "",
      dialogTitle: "",
      dialogAdd1: false,
      dialogAdd2: false,
      dialogAdd3: false,
      dialogAdd4: false,

      dialogEdit1: false,
      dialogEdit2: false,
      dialogEdit3: false,
      dialogEdit4: false,

      dialogCity: false,
      dialogAddCity: false,

      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,

      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      cityTable: [],

      MTOptions: [], //一级下拉框
      MPOptions: [], //二级下拉框
      MSOptions: [], //三家下拉框

      Countryform: {
        CountryId: "",
        Country: "",
        Lever: "1",
      },
      Areaform: {
        CountryId: "",
        Country: "",
        Area: "",
        AreaId: "",
        Lever: "2",
      },
      Centerform: {
        CountryId: "",
        Country: "",
        AreaId: "",
        Area: "",
        CenterId: "",
        Center: "",
        Lever: "3",
      },
      Officeform: {
        CountryId: "",
        Country: "",
        AreaId: "",
        Area: "",
        CenterId: "",
        Center: "",
        Office: "",
        OfficeId: "",
        Lever: "4",
        provinceList: {
          type: Array,
          default: function () {
            return [];
          },
        },
      },
      Cityform: {
        city: [],
        officeId: "",
        regionType: "BV"
      },
      optionRegion: [],
    };
  },
  created: function () {
    this.authOperation("BVRegion");
  },
  async mounted() {
    this.getTableList();
    this.getRegionTree();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasExportAuth = res.hasExportAuth;
    },
    getTableList() {
      let that = this;
      getCustomerRegionTable().then((res) => {
        let data = res.result;
        that.tableData1 = data.countryList.filter(a=>!a.regionType || a.regionType == "BV");
        that.tableData2 = data.areaList.filter(a=>!a.regionType || a.regionType == "BV");
        that.tableData3 = data.centerList.filter(a=>!a.regionType || a.regionType == "BV");
        that.tableData4 = data.officeList.filter(a=>!a.regionType || a.regionType == "BV");
      });
    },
    getRegionTree() {
      let that = this;
      getRegionTree().then((res) => {
        let data = res.result;
        that.optionRegion = data;
      });
    },
    addCustomerCenter() {
      let that = this;
      that.submitLoading = true;
      let dataPost = {};
      if (that.ActiveTab == "Country") {
        dataPost = that.Countryform;
      } else if (that.ActiveTab == "Area") {
        dataPost = that.Areaform;
      } else if (that.ActiveTab == "Center") {
        dataPost = that.Centerform;
      } else {
        dataPost = that.Officeform;
      }
      dataPost.regionType = "BV";
      addCustomerCenter(dataPost)
        .then((res) => {
          that.submitLoading = false;
          that.showDialog(false, that.ActiveTab);
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getTableList();
        })
        .catch((err) => {
          that.submitLoading = false;
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    updateCustomerCenter() {
      let that = this;
      that.submitLoading = true;
      let dataPost = {};
      if (that.ActiveTab == "Country") {
        dataPost = that.Countryform;
      } else if (that.ActiveTab == "Area") {
        dataPost = that.Areaform;
      } else if (that.ActiveTab == "Center") {
        dataPost = that.Centerform;
      } else {
        dataPost = that.Officeform;
      }
      dataPost.regionType = "BV";
      updateCustomerCenter(dataPost).then((res) => {
        that.submitLoading = false;
        that.dialogEdit1 = false;
        that.dialogEdit2 = false;
        that.dialogEdit3 = false;
        that.dialogEdit4 = false;
        that.$message({
          showClose: true,
          message: that.$t("tips.updateSuccess"),
          type: "success",
        });
        that.getTableList();
      }).catch((err) => {
          that.submitLoading = false;
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    delRow(index, row, type) {
      let that = this;
      let data = { Id: row.id };
      deleteCustomerRegion(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          //删除成功直接js处理，也可以后台再获取一遍数据
          if (type == "Country") {
            that.tableData1.splice(index, 1);
          } else if (type == "Area") {
            that.tableData2.splice(index, 1);
          } else if (type == "Center") {
            that.tableData3.splice(index, 1);
          } else {
            that.tableData4.splice(index, 1);
          }
        })
        .catch((err) => {
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    showDialog(visible, row) {
      if (this.ActiveTab == "Country") {
        this.dialogAdd1 = visible;
      } else if (this.ActiveTab == "Area") {
        this.dialogAdd2 = visible;
      } else if (this.ActiveTab == "Center") {
        this.dialogAdd3 = visible;
      } else {
        this.dialogAdd4 = visible;
      }
      //每次打开dialog清楚表格数据
      if (visible) {
        this.MSOptions = [];
        this.MPOptions = [];
        this.resetFormData();
        //打开窗口前重置验证
        if (this.$refs.addRef1.$refs.countryAddRef != undefined) {
          this.$refs.addRef1.$refs.countryAddRef.resetFields();
        }
        if (this.$refs.addRef2.$refs.areaAddRef != undefined) {
          this.$refs.addRef2.$refs.areaAddRef.resetFields();
        }
        if (this.$refs.addRef3.$refs.centerAddRef != undefined) {
          this.$refs.addRef3.$refs.centerAddRef.resetFields();
        }
        if (this.$refs.addRef4.$refs.officeAddRef != undefined) {
          this.$refs.addRef4.$refs.officeAddRef.resetFields();
        }
        let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
        this.$set(this.Countryform, "brand", brand);
        this.$set(this.Areaform, "brand", brand);
        this.$set(this.Centerform, "brand", brand);
        this.$set(this.Officeform, "brand", brand);
      }
    },
    showEditDialog(visible, row) {
      if (this.ActiveTab == "Country") {
        this.dialogEdit1 = visible;
      } else if (this.ActiveTab == "Area") {
        this.dialogEdit2 = visible;
      } else if (this.ActiveTab == "Center") {
        this.dialogEdit3 = visible;
      } else {
        this.dialogEdit4 = visible;
      }
      if (visible) {
        this.getCustomerRegionById(this.ActiveTab, row);
        //打开窗口前重置验证
        if (this.$refs.editRef1.$refs.countryEditRef != undefined) {
          this.$refs.editRef1.$refs.countryEditRef.resetFields();
        }
        if (this.$refs.editRef2.$refs.areaEditRef != undefined) {
          this.$refs.editRef2.$refs.areaEditRef.resetFields();
        }
        if (this.$refs.editRef3.$refs.centerEditRef != undefined) {
          this.$refs.editRef3.$refs.centerEditRef.resetFields();
        }
        if (this.$refs.editRef4.$refs.officeEditRef != undefined) {
          this.$refs.editRef4.$refs.officeEditRef.resetFields();
        }
      } else {
        this.resetFormData();
      }
    },
    showCityDialog(visible, row) {
      this.dialogCity = visible;
      if (visible) {
        this.Cityform.officeId = row.id;
        this.getCityList(row);
      }
    },
    showAddCityDialog(visible) {
      this.dialogAddCity = visible;
      if (visible) {
      }
    },
    delCity(row) {
      let that = this;
      let data = { id: row.id };
      deleteCustomerCity(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: "删除成功！",
            type: "success",
          });
          let value = { id: this.Cityform.officeId };
          this.getCityList(value);
        })
        .catch((err) => {
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    addCity() {
      let that = this;
      that.cityLoading = true;
      addCustomerCity(this.Cityform)
        .then((res) => {
          that.cityLoading = false;
          that.dialogAddCity = false;
          that.$message({
            showClose: true,
            message: "保存成功！",
            type: "success",
          });

          let value = { id: this.Cityform.officeId };
          this.getCityList(value);
        })
        .catch((err) => {
          that.cityLoading = false;
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    getCityList(row) {
      let that = this;
      let postData = { id: row.id };
      getCustomerCityList(postData).then((res) => {
        let data = res.result;
        this.cityTable = data;
      });
    },
    getCustomerRegionById(type, row) {
      let that = this;
      let data = { id: row.id, type: type };
      getCustomerRegionById(data).then((res) => {
        let data = res.result;
        that.MTOptions = that.tableData1.filter(
          (item) => item.id === data.countryId
        );
        that.MPOptions = that.tableData2.filter(
          (item) => item.id === data.areaId
        );
        that.MSOptions = that.tableData3.filter(
          (item) => item.id === data.centerId
        );
        if (type == "Country") {
          this.Countryform = data;
        } else if (type == "Area") {
          this.Areaform = data;
        } else if (type == "Center") {
          this.Centerform = data;
        } else {
          this.Officeform = data;
        }
      });
    },
    resetFormData() {
      this.Countryform = {
        CountryId: "",
        Country: "",
        Lever: "1",
      };
      this.Areaform = {
        CountryId: "",
        Country: "",
        Area: "",
        AreaId: "",
        Lever: "2",
      };
      this.Centerform = {
        CountryId: "",
        Country: "",
        AreaId: "",
        Area: "",
        CenterId: "",
        Center: "",
        Lever: "3",
      };
      this.Officeform = {
        CountryId: "",
        Country: "",
        AreaId: "",
        Area: "",
        CenterId: "",
        Center: "",
        Office: "",
        OfficeId: "",
        Lever: "4",
      };
    },
    selMTChange(value) {
      this.MPOptions = this.tableData2.filter(
        (item) => item.parentId === value
      );
      //修改空压机类型时，产品小类下拉框置空
      this.MSOptions = [];
      this.$set(this.Centerform, "areaId", "");
      this.$set(this.Officeform, "centerId", "");
      this.$set(this.Officeform, "areaId", "");
      // this.KSmallform.kProduct="";
      // this.KPowerform.kSmall="";
      // this.KPowerform.kProduct="";
    },
    selMPChange(value) {
      this.MSOptions = this.tableData3.filter(
        (item) => item.parentId === value
      );
      this.$set(this.Officeform, "centerId", "");
      // this.KPowerform.kSmall="";
    },
    exportCustomerRegionList() {
      let that = this;
      that.loading = true;
      var exportData = [[
        that.$t("title.country"), 
        that.$t("title.region"), 
        that.$t("title.customerCenter"), 
        that.$t("title.liaison"), 
        that.$t("title.chengcity")
      ]];

      var fileName = that.$t("exportContent.BV客户区域列表")+".xlsx";
      let data = new Array();
      for (let index = 0; index < that.tableData4.length; index++) {
        const element = that.tableData4[index];
        element.cityList.map(mapData=>{
          let obj={};
          Object.assign(obj,element);
          obj['city']=mapData;
          data.push(obj);
        })
      }
      // this.pagination.totalPage = res.result.totalCount;
      //导入数据里有null会导致文件损坏
      const dataSource = data.map((item) => {
        Object.keys(item).forEach((key) => {
          // 后端传null node写入会有问题
          if (item[key] === null) {
            item[key] = "";
          }

          // if (Array.isArray(item[key])) {
          //   item[key] = item[key].join(",");
          // }
        });
        return item;
      });
      dataSource.forEach((item) => {
        let rowData = [];
        rowData = [
          item.country,
          item.area,
          item.center,
          item.office,
          item.city,
        ];
        exportData.push(rowData);
      });
      exportExcelNew(exportData, fileName);
      that.loading = false;
    },
    handleClick(tab, event) {},
  },
};
</script>

<style>
</style>
